<template>
    <v-dialog v-model="dialogAbierto" scrollable :fullscreen="$vuetify.breakpoint.xsOnly" max-width="60%">
        <v-card v-if="inscripcion">
            <v-card-title>
                <span class="headline">Registrar pago</span>
            </v-card-title>

            <v-card-text>
                <v-container elevation-3 py-2 px-1>
                    <v-form autocomplete="off">
                        <v-layout row wrap>
                            <v-flex xs12 mb-3 pa-2>
                                <h3 class="headline ">{{ (inscripcion.personas && inscripcion.personas.length > 1 ? 'Equipo' : 'Participante')
                                    }}</h3>
                                <span class="subheading">
                                    {{ (inscripcion.personas && inscripcion.personas.length > 1) ? inscripcion.nombre :
                                        (inscripcion.personas && inscripcion.personas[0] ? inscripcion.personas[0].nombre + ' '
                                        + inscripcion.personas[0].apellido + ' (' + inscripcion.personas[0].documento + ')' : 'Sin datos')
                                    }}
                                </span>
                                <v-divider></v-divider>
                            </v-flex>
                        </v-layout>
                        <v-layout my-2 wrap>


                            <v-flex xs12 md6 pa-2>
                                <v-select v-validate="'required'" :error-messages="errors.collect('medio_pago')"
                                    data-vv-name="medio_pago" v-model="medio_pago" :items="medios_pago" item-text="name"
                                    item-value="value" label="Medio de Pago">
                                </v-select>
                            </v-flex>
                            <v-flex xs12 md6  pa-2>
                                <v-text-field v-validate="'required'" :error-messages="errors.collect('monto_pagado')"
                                    name="monto_pagado" v-model="monto_pagado" data-vv-name="monto_pagado"
                                    label="Monto Pagado" prepend-icon="attach_money"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 pa-2>
                                <v-menu ref="menuDate1" :close-on-content-click="false" v-model="menuDate1"
                                    :nudge-right="40" lazy transition="scale-transition" offset-y full-width
                                    min-width="290px">

                                    <v-text-field v-validate="'required'" :error-messages="errors.collect('fecha_pago')"
                                        name="fecha_pago" slot="activator" v-model="fechaPagoFormateada"
                                        data-vv-name="fecha_pago" label="Fecha del pago"
                                        prepend-icon="event"></v-text-field>

                                    <v-date-picker ref="picker" v-model="fechaPago" min="2017-01-01"
                                        @change="saveDateInicio" locale="es-ar"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md6 pa-2>

                                <v-text-field
                                    label="Hora del pago"
                                    value="00:01"
                                    type="time" 
                                    v-model="hora_pago"
                                    prepend-icon="access_time"
                                ></v-text-field>

                                <!-- <v-menu  ref="menuTime" v-model="menuTime" :close-on-content-click="false" :return-value.sync="hora_pago" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field v-validate="'required'" :error-messages="errors.collect('hora_pago')" name="hora_pago" slot="activator" v-model="hora_pago" data-vv-name="hora_pago" label="Hora del pago" prepend-icon="access_time"></v-text-field>
                                    <v-time-picker ref="timePicker" v-model="horaPago" format="24hr" @change="$refs.menuTime.save(horaPago)"></v-time-picker>
                                </v-menu>

                         -->

                            </v-flex>
                           
                            <v-flex xs12 md6  pa-2>
                                <v-text-field
                                    name="description" v-model="description" data-vv-name="description"
                                    label="Descripción" prepend-icon="description"></v-text-field>
                            </v-flex>

                            <v-flex xs12 pa-1>
                                <v-card>
                                    <v-card-title>
                                        <span class="subheading font-weight-bold">Detalle de monto a abonar</span>
                                       
                                    </v-card-title>
                                    <div>
                                        <v-flex xs12>
                                            <v-layout row wrap justify-center>
                                                <v-flex xs12 pa-3 style="background-color: rgba(255, 157, 0, 0.182);">

                                                    <v-layout row wrap justify-space-between>
                                                        <v-flex xs6>Valor</v-flex>
                                                        <v-flex xs6 text-xs-right
                                                            :class="{ 'tachado': datos_pago.codigo }">
                                                            <span> $ {{ datos_pago.valor_modalidad }}</span>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout v-if="datos_pago.valor_remeras > 0" row wrap justify-space-between>
                                                        <v-flex xs6>Remeras<template v-if="datos_pago.cantidad_remeras > 0 && datos_pago.valor_remera_unitario > 0"> ({{ datos_pago.cantidad_remeras }} x $ {{ datos_pago.valor_remera_unitario }})</template></v-flex>
                                                        <v-flex xs6 text-xs-right> $ {{ datos_pago.valor_remeras }}</v-flex>
                                                    </v-layout>

                                                    <v-layout v-if="datos_pago.codigo" row wrap justify-space-between>
                                                        <v-flex xs6>Valor con descuento</v-flex>
                                                        <v-flex xs6 text-xs-right>
                                                            <span> $ {{ datos_pago.valor }}</span>
                                                        </v-flex>
                                                    </v-layout>



                                                    <v-layout row wrap justify-space-between
                                                        v-if="datos_pago.costo_servicio > 0">
                                                        <v-flex xs6>Costo servicio FinishTime</v-flex>
                                                        <v-flex xs6 text-xs-right> $ {{ datos_pago.costo_servicio }}
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout v-if="datos_pago.codigo" row wrap justify-space-between>
                                                        <v-flex xs6>Cupón aplicado</v-flex>
                                                        <v-flex xs6 text-xs-right> <span>{{ datos_pago.codigo }}
                                                            </span></v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs6 class="title font-weight-black">Total</v-flex>
                                                        <v-flex xs6 text-xs-right class="title font-weight-bold">$ {{
                                                            datos_pago.total }}</v-flex>
                                                    </v-layout>

                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                    </div>
                                </v-card>
                                <v-btn  v-if="hayPagos" @click="showPagos = !showPagos" color="primary" flat  >
                                    Ver pagos ({{ pagos.length }}) <v-icon>{{ showPagos ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                                </v-btn>
                                <div  v-if="showPagos"> 
                                      
                                    <v-card-title>
                                        <span class="subheading">Pagos realizados</span>
                                    </v-card-title>
                                    <div v-if="$vuetify.breakpoint.mdAndUp">
                                        <v-card-text>
                                            <v-data-table
                                                :headers="[
                                                    { text: 'Fecha pago', value: 'fecha_aprobacion', sortable: false },
                                                    { text: 'Tipo de pago', value: 'tipo_pago', sortable: false },
                                                    { text: 'Estado', value: 'estado', sortable: false },
                                                    { text: 'Monto', value: 'monto', sortable: false },
                                                    { text: 'Fecha creación', value: 'fecha_creacion', sortable: false },
                                                    { text: 'Usuario', value: 'user', sortable: false },
                                                ]"
                                                :items="pagos"
                                                class="elevation-1"
                                                hide-default-footer
                                                :items-per-page="pagos.length"
                                            >
                                                <template v-slot:items="props"> 
                                                    <td>{{ props.item.date_approved | formatDateTime }}</td>
                                                    <td>{{ props.item.payment_type }}</td>
                                                    <td>{{ props.item.status_detail }}</td>
                                                    <td>$ {{ props.item.transaction_details.total_paid_amount  }}</td>
                                                    <td>{{ props.item.date_created | formatDateTime }}</td>
                                                    <td>{{ props.item.user_name }}</td>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                        
                                    </div>

                                    <div v-if="$vuetify.breakpoint.smAndDown">
                                         
                                        <v-card-text>
                                            <div v-for="pago in pagos" :key="pago.id">
                                                <v-card class="mb-2" v-for="pago in pagos" :key="pago.id" >
                                                    <v-card-text>
                                                        <v-layout row>
                                                            <v-flex xs6>
                                                                <strong>Fecha/Hora:</strong>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                {{ pago.date_approved | formatDateTime }}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs6>
                                                                <strong>Tipo de pago:</strong>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                {{ pago.payment_type }}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs6>
                                                                <strong>Estado:</strong>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                {{ pago.status_detail }}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs6>
                                                                <strong>Monto:</strong>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                $ {{ pago.transaction_details.total_paid_amount }}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs6>
                                                                <strong>Fecha cargado:</strong>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                {{ pago.date_created | formatDateTime }}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs6>
                                                                <strong>Usuario:</strong>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                {{ pago.user_name }}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </div>
                                        </v-card-text>

                                    </div>
                                </div>

                                <v-flex xs12 pa-1 v-if="hasPaymentReceipt">
                                    <v-card>
                                        <v-card-title>
                                            <span class="subheading font-weight-bold">Comprobante de Pago</span>
                                        </v-card-title>
                                        
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md4 v-if="inscripcionEditar.payment_receipt_uploaded_at">
                                                    <h4 class="caption font-weight-medium">Fecha Carga</h4>
                                                    <span>{{ inscripcionEditar.payment_receipt_uploaded_at | formatDate }}</span>
                                                </v-flex>

                                                <v-flex xs12 sm6 md4 v-if="inscripcionEditar.payment_receipt_size">
                                                    <h4 class="caption font-weight-medium">Tamaño</h4>
                                                    <span>{{ (inscripcionEditar.payment_receipt_size/1024).toFixed(1) }} KB</span>
                                                </v-flex>

                                                <v-flex xs12 class="mt-2">
                                                    <v-btn :href="paymentReceiptUrl" target="_blank" color="primary" small depressed>
                                                        <v-icon left small>cloud_download</v-icon>
                                                        Descargar Comprobante
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <v-divider class="my-3"></v-divider>
                                            
                                            <div v-if="paymentReceiptIsImage">
                                                <h4 class="caption font-weight-medium mb-2">Vista Previa (Imagen)</h4>
                                                <v-img :src="paymentReceiptUrl" max-width="400" contain class="elevation-2"></v-img>
                                            </div>

                                            <div v-else-if="paymentReceiptIsPdf">
                                                <h4 class="caption font-weight-medium mb-2">Vista Previa (PDF)</h4>
                                                <iframe
                                                    :src="paymentReceiptUrl"
                                                    style="width:100%;height:400px;border:1px solid #ccc;border-radius:4px;"
                                                ></iframe>
                                            </div>

                                            <v-alert v-else-if="hasPaymentReceipt" type="info" outlined dense>
                                                No se puede previsualizar este tipo de archivo ({{ inscripcionEditar.payment_receipt_mime }}).
                                                <br>Usa el botón "Descargar" para ver el archivo.
                                            </v-alert>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-flex>

                        </v-layout>


                    </v-form>
                </v-container>


            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="submitting" color="secondary darken-1" flat @click="cerrarDialog">Cancelar</v-btn>
                <v-btn :loading="submitting" color="primary" flat @click="guardarDatos()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import api from "../../../api/inscripcion";
export default {
    props: {
        inscripcion: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            submitting: false,
            datos_pago: {
                valor: 0,
                costo_servicio: 0,
                total: 0,
                codigo: "",
            },
            costo_servicio: "",
            valor: "",
            total: "",
            cupon: "",
            monto_pagado: null,
            description: "",
            medio_pago: null,
            fechaPagoFormateada: "",
            horaPago: null,
            hora_pago: "00:00",
            menuTime: false,
            fechaPago: null,
            menuDate1: null,
            medios_pago: [
                { name: "Transferencia Bancaria", value: "bank_transfer" },
                { name: "Efectivo", value: "cash" }
            ],
            dialogAbierto: false,
            inscripcionEditar: this.inscripcion ? Vue.util.extend({ personas: [] }, this.inscripcion) : { personas: [] },
            showPagos: false,
            pagos: [],
        };
    },
    computed: {
        ...mapGetters("auth", [
            "isLoggedIn",
            "isAdmin",
            "isOrganizador",
            "nombreUsuario",
        ]),
        ...mapState({
            evento: (state) => state.eventos.eventoActual,
            modalidades: (state) => state.eventos.eventoActual.modalidades,
            estados_inscripcion: (state) => state.inscripcion.estados_inscripcion,
        }),
        hayPagos: function () {
            return this.pagos &&  this.pagos.length > 0;
        },
        hasPaymentReceipt() {
        return !!this.inscripcionEditar.payment_receipt_path || !!this.inscripcionEditar.payment_receipt_url;
        },
        paymentReceiptIsImage() {
            if (!this.hasPaymentReceipt) return false;
            const mime = this.inscripcionEditar.payment_receipt_mime || '';
            return mime.indexOf('image/') === 0;
        },
        paymentReceiptIsPdf() {
            if (!this.hasPaymentReceipt) return false;
            const mime = this.inscripcionEditar.payment_receipt_mime || '';
            const path = (this.inscripcionEditar.payment_receipt_path || '').toLowerCase();
            return mime === 'application/pdf' || path.endsWith('.pdf');
        },
        paymentReceiptUrl() {
            return this.inscripcionEditar.payment_receipt_url;
        }
    },
    created() { },
    watch: {
        inscripcion: {
            immediate: true,
            handler(newVal) {
                if (!newVal) {
                    this.inscripcionEditar = { personas: [] };
                    return;
                }
                this.inscripcionEditar = Vue.util.extend({}, newVal);
                // Asegurar que personas siempre sea un array
                if (!this.inscripcionEditar.personas) {
                    this.inscripcionEditar.personas = [];
                }
                if (this.inscripcionEditar && this.inscripcionEditar.id) {
                    this.cargarDatos();
                }
            },
        },
        fechaPago() {
            this.fechaPagoFormateada = this.formatDate(this.fechaPago)
        }
    },
    mounted() { },
    methods: {

        async cargarDatos() {

            const data = await api.getInscripcionConPagos(this.inscripcionEditar.id)
             

            if (!data || data.status != 200) {
                alert("Ocurrio un error")
                this.valor = null;
                this.costo_servicio = null;
                this.total = null;
            } else {
                const { datos_pago } = data.results;
                this.datos_pago = datos_pago;
                this.monto_pagado = datos_pago.total;
                this.medio_pago = "bank_transfer";
                this.pagos = datos_pago.payments;
            }

        },


        async cargarPagos() {

            const data = await api.getInscripcionConPayments(this.inscripcionEditar.id)
            if (!data || data.status != 200) {
                alert("Ocurrio un error")
                this.valor = null;
                this.costo_servicio = null;
                this.total = null;
            }
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        saveDateInicio(date) {
            this.$refs.menuDate1.save(date)
        },
        abrirDialog() {
            this.resetFields();
            this.dialogAbierto = true;

        },
        cerrarDialog() {
            this.dialogAbierto = false;
            this.resetFields();
        },
        resetFields() {
            this.monto_pagado = null;
            this.medio_pago = null;
            this.fechaPago = null;
            this.fechaPagoFormateada = null;
            this.hora_pago = null;
            this.horaPago = null;
            this.description = "";
        },
        async guardarDatos() {

            this.$validator.validateAll().then(async (isOk) => {
                if (isOk) {
                    this.submitting = true;
                    const result = await api.registrarPago(this.inscripcionEditar.id, this.fechaPago, this.hora_pago, this.medio_pago, this.monto_pagado);
                    this.submitting = false;

                    if (!result || !result.isOk) {
                        this.$store.commit('app/SET_MESSAGE', result.message);
                        this.$store.commit('app/SET_SHOW', true);
                    }
                    this.cerrarDialog();
                    this.$emit("refrescarDatos");
                }
            });
        },

    },
};
</script>
